import React, {useRef, useState} from "react";
import {CmaSummary} from "../../../../portfolio/models/CmaSummary";
import {withTranslations} from "../../TranslateService";
import useObservable from "../../utils/hooks/useObservable";
import {CurrentUser} from "../../../../services/user/models/CurrentUser";
import {CurrentUserService} from "../../../../services/user/CurrentUserService";
import {Branding} from "../../../../types/Branding";

import "./BankDetails.scss";
import { SnackBar } from "../SnackBar";
import useSnackBar from "../SnackBar/useSnackBar";

export interface BankDetailsProps {
    summary: CmaSummary | undefined;
    t: any;
    currentUserService: CurrentUserService;
}

const BankDetails = withTranslations((props: BankDetailsProps) => {
    const { summary, t, currentUserService } = props;
    const currentUser = useObservable<CurrentUser>(currentUserService.current);
    const { triggerSnackbar, showSnackbar, snackbarContent } = useSnackBar();

    const copyToClipboard = (str: string) => {
        if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
            triggerSnackbar(`'${str}' copied to clipboard`, 2000);
            return navigator.clipboard.writeText(str);
        }
    };

    if (summary && currentUser?.isBranding(Branding.OPEN_TRADER) === true) {
        const {accountNumber, bsbFormatted} = summary;
        return (
                <div data-component-name="BankDetails" className="bank-details">
                    <div className="bsb-field">
                        <span className="alt-text account-label">{t("equity_portfolio.BANK_ACCOUNT")}<span className="hidden-xs">{": BSB "}</span></span>
                        <span className="hidden-sm hidden-md hidden-lg">{": "}</span>
                        <div className="summary-value">
                            <strong>{bsbFormatted}</strong>
                            <span className="fa fa-clone fa-fw pointer copy-bank-details-icon" onClick={() => {copyToClipboard(bsbFormatted);}}></span>
                        </div>
                    </div>

                    <div>
                        <span className="hidden-xs alt-text">{t("equity_portfolio.ACCT_NO")}{": "}</span>
                        <div className="summary-value">
                            <strong>{accountNumber}</strong>
                            <span className="fa fa-clone fa-fw pointer copy-bank-details-icon" onClick={() => {copyToClipboard(accountNumber);}}></span>
                        </div>
                    </div>
                    <SnackBar active={showSnackbar} content={snackbarContent}/>
                </div>
        );
    } else {
        return "";
    }
});

export { BankDetails };
